// @src/pages/NotFound.jsx
const NotFound = () => (
    <div>
      <h1>Not Found page</h1>
      <p>The page you tried to access doesn't exist.</p>
      <p>This is a generic route.</p>
    </div>
  );
  export default NotFound;